export const RESPONSE_ACTION_KEY_PATH = ['data', 'viewer', 'action'];

export const ACTION_CHILD_ID_KEY_PATH = ['child', 'id'];

export const ACTION_PERSON_FLOW_ID_KEY_PATH = ['child', 'personFlowId'];

export const ACTION_FLOW_ID_KEY_PATH = ['child', 'flowId'];
